import { Controller } from "@hotwired/stimulus"

// Header navigation: a link to a section of the current page scrolls there smoothly (instantly
// for visitors who prefer reduced motion) and closes the phone menu. Links to other pages, and
// home page anchors followed from a sub page, stay with Turbo, which jumps without animation.
// Smooth scrolling is done here rather than with `scroll-behavior: smooth` in CSS, since Turbo
// scrolls on every page change and would animate those as well.
export default class extends Controller {
  static targets = ["menu"]

  navigate(event) {
    const link = event.target.closest("a[href*='#']")
    if (!link) return

    const url = new URL(link.href)
    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return

    const section = document.getElementById(decodeURIComponent(url.hash.slice(1)))
    if (!section) return

    event.preventDefault()
    if (this.hasMenuTarget) this.menuTarget.open = false

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    section.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" })
    // Keyboard and screen reader users continue from the section, as after Turbo's own jump.
    section.setAttribute("tabindex", "-1")
    section.focus({ preventScroll: true })
    section.removeAttribute("tabindex")
    // Show the section in the address bar; replacing keeps Turbo's restoration data in the entry.
    window.history.replaceState(window.history.state, "", url.hash)
  }
}
